import { PERSON_RECEIVE, PERSON_ERROR, PERSON_CHANGE_MODE } from '../../Actions/Person.action';
import { ADDRESS_RECEIVE, ADDRESS_ERROR, ADDRESS_CHANGE_MODE } from '../../Actions/Address.action';
import { MONITOR_RECEIVE } from '../Actions/Monitor.action';
import { person as personReducer } from '../../Reducers/Person.reducer';
import { address as addressReducer } from '../../Reducers/Address.reducer';
import { monitor as monitorReducer } from '../Reducers/Monitor.reducer';

const defaultState = {
    persons: {},
    addresses: {},
    monitors: {},
}

export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            }
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            }
        case MONITOR_RECEIVE:
            return {
                ...state,
                monitors: monitorReducer(state.monitors, action),
            }
        default:
            return state;
    }
}